import { stage01 } from './Stage01';
import { stage02 } from './Stage02';
import { stage03 } from './Stage03';
import { stage07 } from './Stage07';
import { stage06 } from './Stage06';
import { stage05 } from './Stage05';
import { stage04 } from './Stage04';
import { stage09 } from './Stage09';
import { stage08 } from './Stage08';
import { stage10 } from './Stage10';
import { stage11 } from './Stage11';
import { stage12 } from './Stage12';
import { stage13 } from './Stage13';
import { stage15 } from './Stage15';
import { stage16 } from './Stage16';
import { stage14 } from './Stage14';

export const stages = [
    stage01,
    stage02,
    stage03,
    stage04,
    stage05,
    stage06,
    stage07,
    stage08,
    stage09,
    stage10,
    stage11,
    stage12,
    stage13,
    stage14,
    stage15,
    stage16,
];
